<template>
  <div class="mb-3">
    <div class="subtitle-2">{{ $t('crudUnidades.form.balanco.title') }}</div>
    <div class="caption text--secondary mb-2">{{ $t('crudUnidades.form.balanco.hint') }}</div>
    <v-progress-linear v-if="loading" indeterminate class="mb-2" />
    <div v-else-if="!itens.length" class="caption text--secondary mb-2">
      {{ $t('crudUnidades.form.balanco.empty') }}
    </div>
    <template v-else>
      <v-row
        v-for="item in itens"
        :key="item.id_tipo_veiculo"
        dense
        align="center"
        class="unidade-balanco-linha"
      >
        <v-col cols="8" sm="9" md="4" class="text-body-2">
          {{ item.descricao }}
        </v-col>
        <v-col cols="4" sm="3" md="2">
          <v-text-field
            v-model.number="item.percentual"
            type="number"
            min="0"
            max="100"
            step="0.01"
            suffix="%"
            dense
            hide-details="auto"
            :rules="percentualRules"
            :aria-label="$t('crudUnidades.form.balanco.percent')"
          />
        </v-col>
      </v-row>
      <v-alert
        v-if="mostraAlertaSoma"
        type="error"
        dense
        outlined
        class="mt-2 mb-0"
      >
        {{ $t('crudUnidades.form.balanco.sumError', { total: totalLabel }) }}
      </v-alert>
      <div v-else-if="total > 0" class="caption text--secondary mt-1">
        {{ $t('crudUnidades.form.balanco.total', { total: totalLabel }) }}
      </div>
    </template>
  </div>
</template>

<script>
import { balancoPercentuaisErro, balancoTotal } from '@/utils/unidadeBalanco';

export default {
  name: 'UnidadeBalancoTiposVeiculo',
  props: {
    /** [{ id_tipo_veiculo, descricao, percentual }] — o percentual é editado no próprio item. */
    itens: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    total() {
      return balancoTotal(this.itens);
    },
    totalLabel() {
      return String(this.total).replace('.', ',');
    },
    mostraAlertaSoma() {
      return balancoPercentuaisErro(this.itens) !== null;
    },
    percentualRules() {
      return [
        (v) => v === '' || v == null
          || (Number.isFinite(Number(v)) && Number(v) >= 0 && Number(v) <= 100)
          || this.$t('crudUnidades.form.balanco.rangeError'),
      ];
    },
  },
};
</script>

<style scoped>
.unidade-balanco-linha {
  max-width: 560px;
}
</style>
